// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".answer-img .el-image{width:100%;height:100%}.answer-img .el-image-viewer__close{top:110px;color:#fff}.padPictures{text-align:center}.padPictures button{background-color:#f0f0f0;font-weight:700;color:#000;border:none}", ""]);
// Exports
module.exports = exports;
